import styled from 'styled-components';

import MaskImage from 'assets/img/hexa-mask.png';

export const Container = styled.div`
  width: fit-content;
  margin: 0 auto;

  position: relative;
  top: -120.4px;

  .profile-image__content-image,
  .profile-image__content-before-image{
    mask-image: url(${MaskImage});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  }

  .profile-image__content-before-image{
    width: 132.34px;
    height: 152.03px;

    position: absolute;
    bottom: 0;
    left: 0;

    display: inline-block;

    background: rgb(40,133,219);
    background: linear-gradient(30deg, rgba(40,133,219,1) 0%, rgba(255,255,255,1) 100%);
  }

  .profile-image__content-image{
    width: 162.96px;
    height: 187.2px;
    margin: 0 17.8px 0 18.4px;

    object-fit: cover;
    background-color: var(--bluef0);
  }

  .profile-image__content-edit-button{
    width: 51.96px;
    height: 45.23px;

    position: absolute;
    right: 0;
    bottom: 27.4px;

    border: 0;
    outline: none;
    background: transparent;
    cursor: pointer;
  }
`
